// File: components/terms-rates.js

import React from 'react';
import './terms-conditions.css'; // Custom styles for this component

const TermsRatesComponent = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Terms & Rates</h1>
      </header>

      <section className="tc-content mb-3">
        <h2>How is APR determined?</h2>
        <p>
          Annual percentage rate(APR) is determined based on your credit score, the amount you wish to borrow and your steady income. Generally, a good CIBIL score calls for a low APR while a poor CIBIL score means high APR. But we have a fixed APR which is the same for all.
        </p>

        <h2>Working of Our Rates & Fees</h2>
        <p>
          APR reflects the true cost of borrowing money. It includes the annual interest rate, a nominal
          processing fee and other miscellaneous expenses. APR is usually lower than your credit card interest
          rate. APR is the actual annual cost of your loan that helps you compare various loan offers from
          different lenders. We have upto 240% to 365% APR.
        </p>

        {/* Table */}
        <div className="table-responsive mt-4">
          <table className="table table-bordered text-center align-middle">
            <thead className="table-light">
              <tr>
                <th>Loan Amount</th>
                <th>APR</th>
                <th>Tenure</th>
                <th>Processing Fee</th>
                <th>GST on Processing Fee</th>
                <th>Amount Disbursed</th>
                <th>EMI</th>
                <th>Total Repayment Amount</th>
                <th>Total Interest</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>₹50,000</td>
                <td>240% to 365%</td>
                <td>7–365 Days</td>
                <td>₹4,000-5,000</td>
                <td>18%</td>
                <td>₹45,000-46,000</td>
                <td>₹20,000</td>
                <td>₹60,000</td>
                <td>₹10,000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default TermsRatesComponent;
